/**
 * 確保測量容器中的 <br> 標籤不佔用高度
 * 因為實際樣式中 br { display: none; }
 */
const applyBrStyles = (container) => {
  const brElements = container.querySelectorAll('br');
  brElements.forEach(br => {
    br.style.display = 'none';
  });
};

/**
 * 創建用於測量的臨時容器
 */
export const createMeasureContainer = (referenceContainer) => {
  const measureContainer = document.createElement('div');
  const containerStyle = window.getComputedStyle(referenceContainer);
  
  measureContainer.style.position = 'absolute';
  measureContainer.style.visibility = 'hidden';
  measureContainer.style.width = referenceContainer.offsetWidth + 'px';
  measureContainer.style.fontSize = containerStyle.fontSize;
  measureContainer.style.lineHeight = containerStyle.lineHeight;
  measureContainer.style.fontFamily = containerStyle.fontFamily;
  measureContainer.className = referenceContainer.className;
  
  // 添加一個方法，用於在設置 innerHTML 後應用 br 樣式
  measureContainer.setHTMLAndApplyBrStyles = function(html) {
    this.innerHTML = html;
    applyBrStyles(this);
  };
  
  return measureContainer;
};
